import { render, staticRenderFns } from "./CarouselMenu.vue?vue&type=template&id=6a9061f2&"
import script from "./CarouselMenu.vue?vue&type=script&lang=js&"
export * from "./CarouselMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports